import {
  Patient,
  Doctor,
  Appointment,
  Service,
  Insurance,
  Specialty,
  Contact,
  Company,
  Opportunity,
  ClinicalHistory,
  MedicalHistory,
} from '../types'
import { getToday } from './helpers'

const emptyMedicalHistory: MedicalHistory = {
  initialInterview: {
    background: '',
    visitReason: '',
    allergies: '',
    currentMedications: '',
    familyHistory: '',
  },
  symptoms: {
    description: '',
    duration: '',
    severity: '',
    notes: '',
  },
  physicalExam: {
    bloodPressure: '',
    bloodSugar: '',
    heartRate: '',
    lungs: '',
    eyes: '',
    throat: '',
    abdomen: '',
    weight: '',
    height: '',
    temperature: '',
  },
  instruments: [],
  diagnosis: '',
  recommendations: '',
  entries: [],
}

export const createInitialData = () => {
  const specialties: Specialty[] = [
    {
      id: 'sp1',
      name: 'Medicina General',
      description: 'Atención médica primaria',
    },
    { id: 'sp2', name: 'Cardiología', description: 'Especialidad del corazón' },
    { id: 'sp3', name: 'Pediatría', description: 'Atención médica infantil' },
    { id: 'sp4', name: 'Dermatología', description: 'Especialidad de la piel' },
    {
      id: 'sp5',
      name: 'Oftalmología',
      description: 'Especialidad de los ojos',
    },
    { id: 'sp6', name: 'Ginecología', description: 'Salud femenina' },
    { id: 'sp7', name: 'Traumatología', description: 'Lesiones y fracturas' },
    { id: 'sp8', name: 'Neurología', description: 'Sistema nervioso' },
  ]

  const insurances: Insurance[] = [
    {
      id: 'ins1',
      name: 'ARS Humano',
      company: 'Humano Seguros',
      coverageType: 'Completo',
      phone: '809-555-0001',
      email: 'info@humano.com',
    },
    {
      id: 'ins2',
      name: 'ARS Palic',
      company: 'Palic Salud',
      coverageType: 'Básico',
      phone: '809-555-0002',
      email: 'info@palic.com',
    },
    {
      id: 'ins3',
      name: 'Senasa',
      company: 'Gobierno RD',
      coverageType: 'Subsidiado',
      phone: '809-555-0003',
      email: 'info@senasa.gob.do',
    },
    {
      id: 'ins4',
      name: 'ARS Universal',
      company: 'Universal Seguros',
      coverageType: 'Premium',
      phone: '809-555-0004',
      email: 'info@universal.com',
    },
    {
      id: 'ins5',
      name: 'ARS Reservas',
      company: 'Banco de Reservas',
      coverageType: 'Completo',
      phone: '809-555-0005',
      email: 'info@reservas.com',
    },
  ]

  const services: Service[] = [
    {
      id: 'srv1',
      name: 'Consulta General',
      duration: 30,
      price: 1500,
      description: 'Consulta médica general',
    },
    {
      id: 'srv2',
      name: 'Consulta Especializada',
      duration: 45,
      price: 2500,
      description: 'Consulta con especialista',
    },
    {
      id: 'srv3',
      name: 'Chequeo Completo',
      duration: 60,
      price: 5000,
      description: 'Examen médico completo',
    },
    {
      id: 'srv4',
      name: 'Electrocardiograma',
      duration: 20,
      price: 1800,
      description: 'Estudio del corazón',
    },
    {
      id: 'srv5',
      name: 'Examen de Vista',
      duration: 30,
      price: 1200,
      description: 'Evaluación oftalmológica',
    },
    {
      id: 'srv6',
      name: 'Vacunación',
      duration: 15,
      price: 800,
      description: 'Aplicación de vacunas',
    },
  ]

  const doctors: Doctor[] = [
    {
      id: 'doc1',
      name: 'Carlos Méndez',
      specialtyId: 'sp1',
      phone: '809-555-1001',
      email: 'carlos.mendez@savidna.com',
      schedule: {
        monday: { start: '08:00', end: '17:00' },
        tuesday: { start: '08:00', end: '17:00' },
        wednesday: { start: '08:00', end: '17:00' },
        thursday: { start: '08:00', end: '17:00' },
        friday: { start: '08:00', end: '14:00' },
        saturday: null,
        sunday: null,
      },
      createdAt: new Date(),
    },
    {
      id: 'doc2',
      name: 'María Rodríguez',
      specialtyId: 'sp2',
      phone: '809-555-1002',
      email: 'maria.rodriguez@savidna.com',
      schedule: {
        monday: { start: '09:00', end: '18:00' },
        tuesday: { start: '09:00', end: '18:00' },
        wednesday: { start: '09:00', end: '18:00' },
        thursday: { start: '09:00', end: '18:00' },
        friday: { start: '09:00', end: '15:00' },
        saturday: { start: '09:00', end: '13:00' },
        sunday: null,
      },
      createdAt: new Date(),
    },
    {
      id: 'doc3',
      name: 'Juan Pérez',
      specialtyId: 'sp3',
      phone: '809-555-1003',
      email: 'juan.perez@savidna.com',
      schedule: {
        monday: { start: '07:00', end: '15:00' },
        tuesday: { start: '07:00', end: '15:00' },
        wednesday: { start: '07:00', end: '15:00' },
        thursday: { start: '07:00', end: '15:00' },
        friday: { start: '07:00', end: '12:00' },
        saturday: null,
        sunday: null,
      },
      createdAt: new Date(),
    },
  ]

  const patients: Patient[] = [
    {
      id: 'pat1',
      name: 'Ana López',
      age: 35,
      gender: 'femenino',
      phone: '809-555-2001',
      email: 'ana.lopez@email.com',
      address: 'Calle Principal #123, Santo Domingo',
      emergencyContact: {
        name: 'Carlos López',
        relationship: 'Esposo',
        phone: '809-555-2010',
      },
      insuranceId: 'ins1',
      medicalHistory: emptyMedicalHistory,
      interactions: [],
      createdAt: new Date(),
    },
    {
      id: 'pat2',
      name: 'Pedro Martínez',
      age: 45,
      gender: 'masculino',
      phone: '809-555-2002',
      email: 'pedro.martinez@email.com',
      address: 'Av. Independencia #456, Santiago',
      emergencyContact: {
        name: 'María Martínez',
        relationship: 'Esposa',
        phone: '809-555-2020',
      },
      insuranceId: 'ins2',
      medicalHistory: emptyMedicalHistory,
      interactions: [],
      createdAt: new Date(),
    },
    {
      id: 'pat3',
      name: 'Lucía Fernández',
      age: 28,
      gender: 'femenino',
      phone: '809-555-2003',
      email: 'lucia.fernandez@email.com',
      address: 'Calle Las Flores #789, La Romana',
      emergencyContact: {
        name: 'Rosa Fernández',
        relationship: 'Madre',
        phone: '809-555-2030',
      },
      insuranceId: 'ins3',
      medicalHistory: emptyMedicalHistory,
      interactions: [],
      createdAt: new Date(),
    },
  ]

  const today = getToday()
  const tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  const tomorrowStr = tomorrow.toISOString().split('T')[0]

  const appointments: Appointment[] = [
    {
      id: 'apt1',
      patientId: 'pat1',
      doctorId: 'doc1',
      serviceId: 'srv1',
      date: today,
      time: '09:00',
      duration: 30,
      status: 'programada',
      notes: 'Primera visita del año',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    {
      id: 'apt2',
      patientId: 'pat2',
      doctorId: 'doc2',
      serviceId: 'srv2',
      date: today,
      time: '10:30',
      duration: 45,
      status: 'programada',
      notes: 'Control de presión arterial',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    {
      id: 'apt3',
      patientId: 'pat3',
      doctorId: 'doc1',
      serviceId: 'srv3',
      date: tomorrowStr,
      time: '14:00',
      duration: 60,
      status: 'programada',
      notes: 'Chequeo completo',
      createdAt: new Date(),
      updatedAt: new Date(),
    },
  ]

  const contacts: Contact[] = [
    {
      id: 'con1',
      name: 'Roberto Sánchez',
      phone: '809-555-3001',
      email: 'roberto@empresa.com',
      company: 'Empresa ABC',
      position: 'Gerente de RRHH',
      notes: 'Interesado en plan corporativo',
      interactions: [],
      createdAt: new Date(),
    },
    {
      id: 'con2',
      name: 'Carmen Díaz',
      phone: '809-555-3002',
      email: 'carmen@corporacion.com',
      company: 'Corporación XYZ',
      position: 'Directora de Bienestar',
      notes: 'Contacto referido',
      interactions: [],
      createdAt: new Date(),
    },
  ]

  const companies: Company[] = [
    {
      id: 'comp1',
      name: 'Empresa ABC',
      industry: 'Tecnología',
      size: '50-100 empleados',
      location: 'Santo Domingo',
      phone: '809-555-4001',
      email: 'contacto@empresaabc.com',
      website: 'www.empresaabc.com',
      notes: 'Cliente importante',
      createdAt: new Date(),
    },
    {
      id: 'comp2',
      name: 'Corporación XYZ',
      industry: 'Manufactura',
      size: '100-500 empleados',
      location: 'Santiago',
      phone: '809-555-4002',
      email: 'info@corporacionxyz.com',
      website: 'www.corporacionxyz.com',
      notes: 'Potencial para expansión',
      createdAt: new Date(),
    },
  ]

  const opportunities: Opportunity[] = [
    {
      id: 'opp1',
      name: 'Plan Corporativo ABC',
      contactId: 'con1',
      companyId: 'comp1',
      company: 'Empresa ABC',
      industry: 'Tecnología',
      size: '50-100 empleados',
      location: 'Santo Domingo',
      stage: 'evaluacion',
      amount: 150000,
      probability: 60,
      notes: 'Reunión programada para próxima semana',
      interactions: [],
      createdAt: new Date(),
      updatedAt: new Date(),
    },
    {
      id: 'opp2',
      name: 'Servicios Médicos XYZ',
      contactId: 'con2',
      companyId: 'comp2',
      company: 'Corporación XYZ',
      industry: 'Manufactura',
      size: '100-500 empleados',
      location: 'Santiago',
      stage: 'contacto_inicial',
      amount: 250000,
      probability: 30,
      notes: 'Primer contacto realizado',
      interactions: [],
      createdAt: new Date(),
      updatedAt: new Date(),
    },
  ]

  return {
    specialties,
    insurances,
    services,
    doctors,
    patients,
    appointments,
    contacts,
    companies,
    opportunities,
    clinicalHistories: [] as ClinicalHistory[],
  }
}

// Export function for DataContext to use
export const getInitialData = createInitialData
